export default __webpack_public_path__ + "static/media/one.1bce38db.jpeg";